module.exports = __webpack_public_path__ + "img/puericulture-h.9e1652d9.jpg";